export default __webpack_public_path__ + "static/media/aInvest.767ac5bb.svg";